
    <ezs-email-registration
      [user]="user$ | async"
      [requestStatus]="registrationStatus"
      [requestError]="registrationError"
      (registerEmail)="registerNewUser($event)">
    </ezs-email-registration>
  